<template>
  <v-file-input
    v-model="сomputedAttachments"
    :rules="[(v) => !required || !!v || $t('field-requied')]"
    :label="label"
    :accept="accept"
    :multiple="multiple"
    :counter="multiple"
    :show-size="сomputedShowSize"
    :prepend-inner-icon="mdiPaperclip"
    class="body-2"
    placeholder=" "
    prepend-icon
    clearable
    outlined
  >
    <template v-slot:selection="{ text }">
      <v-chip small outlined pill color="primary">
        {{ text }}
      </v-chip>
    </template>
  </v-file-input>
</template>

<script>
import { mdiPaperclip } from "@mdi/js";
export default {
  name: "FieldFile",
  props: {
    label: String,
    accept: String,
    required: Boolean,
    multiple: Boolean,
    initialAttachment: [String, Array, File],
  },
  data: () => ({ attachments: null, mdiPaperclip }),
  mounted() {
    if (this.initialAttachment) {
      if (this.initialAttachment.constructor === Array) {
        this.attachments = this.initialAttachment.map((name) => ({
          name: name.replace(/^.*[\\\/]/, ""),
        }));
      } else if (this.initialAttachment.constructor === String) {
        this.attachments = {
          name: this.initialAttachment.replace(/^.*[\\\/]/, ""),
        };
      } else {
        this.attachments = this.initialAttachment;
      }
    }
  },
  computed: {
    сomputedShowSize() {
      return (
        this.attachments && this.attachments[0] && this.attachments[0].size > 0
      );
    },
    сomputedAttachments: {
      get() {
        return this.attachments;
      },
      set(value) {
        this.attachments = value;
        this.$emit("attrUpdate", value);
      },
    },
  },
};
</script>
